import React, { FC, useEffect, useState } from 'react';
import { useAsync } from 'react-use';
import { useRouter } from 'next/router';
import { Button, Card, Col, Grid, Image, Row, Typography } from 'antd';
import g from 'src/constants/urls';
import { formatDateListArticels, formatDateListArticelsMobile } from 'src/utils/func/format-date';
import classes from './article.module.less';
interface CardArticleInterface {
  data?: any;
  type?: any;
}
const CardArticleHBSection3New: FC<CardArticleInterface> = props => {
  const {
    xs
  } = Grid.useBreakpoint();
  const firstData = props.data;
  const [count, setCount] = useState(1);
  const [mergeData, setMergeData] = useState<any>([]);
  const [pagination, setPagination] = useState<any>();
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const dataToUse = count > 1 ? mergeData : firstData;
  useEffect(() => {
    setMergeData(firstData);
    setPagination({
      page: 0,
      total_page: 1
    });
    setCount(1);
  }, [firstData]);
  const handleClick = () => {
    setCount(count + 1);
    setLoading(true);
  };
  useAsync(async () => {
    try {
      const queryUrl = router.query;
      const queryPhase = queryUrl.phase === 'pra-kehamilan' ? 'pre-pregnancy' : queryUrl.phase === 'pasca-kehamilan' ? 'post-pregnancy' : 'pregnancy';
      const filters = `orderby=desc&orderby=show_as_banner%2Cpublish_date%2Ctotal_like&page=${count}&per_page=10&show_as_banner=false`;
      const uri = `${g.API_ARTICLE}/${queryPhase}?group=${queryUrl.group}&category=${queryUrl.category === 'buat-mama' ? '' : queryUrl.category}&${filters}`;
      const opts = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
      const faqList = await fetch(uri, opts);
      const data: any = await faqList.json().then(res => ({
        ...res,
        status: faqList.status
      }));
      if (data?.status === 200) {
        const newData = data.data.records;
        setMergeData([...mergeData, ...newData]);
        setLoading(false);
        setPagination(data.meta.pagination);
      } else {
        setMergeData([...mergeData]);
        setLoading(false);
      }
    } catch (error) {}
  }, [count]);
  return <div className={classes.containerCard}>
			<Row>
				{xs ? dataToUse?.map((item: any) => {
        const dataPhase = item.type === 'pregnancy' ? 'kehamilan' : item.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
        return <Col sm={8} md={8} lg={8} xl={8} xs={24} key={item.uid}>
								<a href={`/${dataPhase}/${item.slug}`}>
									<span>
										<Card key={item.id} size="small" hoverable={false} className={`${classes.cards} ${classes.noPaddingCard}`} style={{
                cursor: 'pointer',
                marginLeft: '-12px',
                marginRight: '-12px',
                padding: 0
              }}>
											<Row>
												<Col xs={11}>
													<Image alt={item.title} src={item.media_images.original} className={classes.imageContainer} style={{
                      borderRadius: xs ? '8px' : '14px',
                      objectFit: 'cover'
                    }} preview={false} loading='lazy' width={135} height={73} />
												</Col>
												<Col xs={13}>
													<div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      height: '73px',
                      boxSizing: 'border-box'
                    }}>
														<Typography className={classes.category} style={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1.5,
                        maxHeight: '2 em'
                      }}>
															{item.category_name}
														</Typography>
														<Typography className={classes.title} style={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1.5,
                        maxHeight: '2 em'
                      }}>
															{item.title}
														</Typography>
														<Typography className="fs-11 fs-md-12" style={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1.5,
                        maxHeight: '2 em',
                        marginLeft: '-9px'
                      }}>
															Diterbitkan pada {formatDateListArticelsMobile(item.publish_date)}
														</Typography>
														{/* <Typography
               className="fs-12 fs-md-14"
               style={{
               	color: '#9ca3aa',
               	overflow: 'hidden',
               	textOverflow: 'ellipsis',
               	whiteSpace: 'nowrap',
               	width: '80%',
               	display: 'block',
               	marginLeft: '-10px',
               }}>
               {item.short_desc}
               </Typography> */}
													</div>
												</Col>
											</Row>
										</Card>
									</span>
								</a>
							</Col>;
      }) : dataToUse?.map((item: any) => {
        const dataPhase = item.type === 'pregnancy' ? 'kehamilan' : item.type === 'pre-pregnancy' ? 'pra-kehamilan' : 'pasca-kehamilan';
        return <Col sm={12} md={12} lg={12} xl={12} xs={24} key={item.uid}>
								<a href={`/${dataPhase}/${item.slug}`}>
									<Card key={item.id} size="small" hoverable={false} className={classes.cardsWeb} style={{
              cursor: 'pointer'
            }}>
										<Row>
											<Col span={12}>
												<Image alt={item.title} src={item.media_images.original} className={classes.imageContainer} style={{
                    borderRadius: '20px',
                    objectFit: 'cover'
                  }} preview={false} loading='lazy' width={252} height={140} />
											</Col>
											<Col span={12}>
												<div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    height: '140px',
                    width: '100%',
                    padding: '16px',
                    boxSizing: 'border-box'
                  }}>
													<Typography className={classes.category}>
														{item.category_name}
													</Typography>
													<Typography className={classes.title} style={{
                      display: '-webkit-box',
                      overflow: 'hidden',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: 2,
                      lineHeight: 1.2,
                      maxHeight: '2 em',
                      width: '100%'
                    }}>
														{item.title}
													</Typography>
													<Typography className="fs-11 fs-md-13">
														Diterbitkan pada {formatDateListArticels(item.publish_date)}
													</Typography>
													<Typography className="fs-12 fs-md-14" style={{
                      color: '#9ca3aa',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      width: '100%',
                      display: 'block'
                    }}>
														{item.short_desc}
													</Typography>
												</div>
											</Col>
										</Row>
									</Card>
								</a>
							</Col>;
      })}
			</Row>
			<div className={classes.btnFooter}>
				{firstData.length <= 9 ? '' : firstData.length > 0 && pagination?.page < pagination?.total_page ? <Button className={classes.btn} onClick={handleClick} loading={loading} size="large">
								Lihat Artikel Lainnya
							</Button> : firstData.length === 0 ? '' : pagination?.page >= pagination?.total_page && ''}
			</div>
		</div>;
};
export default CardArticleHBSection3New;